'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TOGGLE_INITIAL_MESSAGE_BUBBLE = exports.TOGGLE_INITIAL_MESSAGE_BUBBLE = 'TOGGLE_INITIAL_MESSAGE_BUBBLE';